import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';

export interface ConfirmationCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle(): object;
    getTitleCSSStyle(): object;
    getMessageDivCSSStyle():object;
    getLoginButtonCSSStyle():object;
   
}

export class ConfirmationCSSStyleImpl extends UIComponentCSSStyleImpl implements ConfirmationCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginLeft: "10px",
            marginRight: "10px",
            marginTop: "150px",
            marginBottom: "150px",
            borderRadius: "4px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "1px solid " + this.getResources().getColor(Colors.color_5),
        };
    }

    getInnerWrapperCSSStyle(): object 
    {
        return {
            // backgroundColor: this.getResources().getColor(Colors.color_5),
            flex: 0.68,
            // justifyContent: "left",
            // textAlign: "left",      
            marginTop: "40px",
            marginBottom: "40px",
            width: '100%',
            padding: '0px 20px'
        };
    }

    getTitleCSSStyle(): object {
        return {
         

            display: "flex",
            // textAlign: "left",
            // height: "40px",
            width: "300px",
            fontWeight: "bold",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h13),
            color:this.getResources().getColor(Colors.color_6),
            lineHeight: "40px",
            fontFamily:this.getContext().getResources().getFontFamily()

        };
    }
    getMessageDivCSSStyle():object{
        return{
            // width:'528px',
            height:'40px',
            display: "inline-block",
            // textAlign: "left",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_6),
            lineHeight: "40px",
            marginTop:'30px',
            fontFamily: this.getResources().getFontFamily()

        };
    }
    getLoginButtonCSSStyle(): object 
    {
        return {
            width:'180px',
            marginTop: "54px",
        };
    }


}    



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/confirmation/confirmationcss.tsx